import { MEMBER_STATUS } from "constants/member";

import { db, FieldValue } from 'helpers/firebase';
const serverTimestamp = FieldValue.serverTimestamp;

export const getUserIdsByOrgId = (org_id) => {
  console.log(`org_id = ${org_id}`);

  return db.collection('/users')
    .where('org_id', '==', org_id)
    .get()
    .then(colSnap => {
      console.log('colSnap: ', colSnap.size);
      return colSnap.docs.map(doc => ({ user_id: doc.id, old_id: doc.data().old_id }))
    })
    .catch(e => console.error("failed getUserIdByOldId: ", e))
}

export const saveGameResult = (user_id, data) => {
  return db.collection(`/users/${user_id}/game_results`).doc()
    .set(data);
}